import axios from 'axios';
import compressImage from 'utils/imageCompression';
import { UPLOAD_IMAGE_SITE } from '../../queries/site';
import { getUri } from '../../utils/uri';
import { readFileAsync } from '../../utils/readFileAsync';

export class UploadAdapter {
  constructor(loader, siteDomain) {
    this.loader = loader;
    this.siteDomain = siteDomain;
  }

  async uploadImageSiteDomain(readerResult) {
    try {
      const uri = getUri(window.location.hostname);
      let imageUrl = readerResult;
      const headers = {
        'content-type': 'application/json',
        authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      };
      const response = await axios({
        url: uri,
        method: 'POST',
        data: {
          query: UPLOAD_IMAGE_SITE,
          variables: {
            file: readerResult,
            siteDomain: this.siteDomain,
          },
        },
        headers,
      });
      const { data: { data: { uploadImageContent: { url } } } } = response;
      if (url) {
        imageUrl = url;
      }
      return ({ default: imageUrl });
    } catch (error) {
      throw new Error('Failed to upload image!');
    }
  }

  async upload() {
    try {
      const file = await compressImage(await this.loader.file);
      const readerResult = await readFileAsync(file);
      return this.uploadImageSiteDomain(readerResult);
    } catch (error) {
      throw new Error(error);
    }
  }
}
